import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as firebase from "firebase";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { createBrowserHistory } from "history";

import "./styles.css";
import AppRouter from "./router";
import store from "./store";
import config from "./config";


const browserHistory = createBrowserHistory();

firebase.initializeApp(config.firebase);

Sentry.init({
    dsn: config.sentry.dsn,
    integrations: [new Integrations.BrowserTracing(
      {
        routingInstrumentation: Sentry.reactRouterV4Instrumentation(browserHistory)

      }
    )],
    tracesSampleRate: 1.0,
    environment: config.sentry.environment
  }
);

ReactDOM.render(
  <Provider store={store}>
    <AppRouter />
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js